import _Vue, { DirectiveOptions } from 'vue'
import mitt, { Emitter } from 'mitt'

/**
 * 解决 iOS webview 中，软件盘弹起页面不回滚到底部的问题
 */

// className
const CLEAR = 'clear'
const MD_ICON = 'md-icon'
const MD_ICON_CLEAR = 'md-icon-clear'

// ua test
const isIOS = () =>
  /iphone os/i.test(
    window.navigator.userAgent.toLowerCase()
  )

// emitter
const emitter = (function () {
  let _emitter: null | Emitter = null
  return function () {
    if (!_emitter) {
      _emitter = mitt()
    }
    return _emitter
  }
})()()

let currentDom = null
function fakeFocusin({ dom }: { dom: HTMLElement }) {
  currentDom = dom
  dom.dataset['isFocusin'] = '1'
  const originTop =
    document.documentElement.scrollTop ||
    document.body.scrollTop
  dom.dataset['originTop'] = originTop + ''
}

function fakeFocusout({ dom }: { dom: HTMLElement }) {
  dom.dataset['isFocusin'] = '0'
  const originTop = dom.dataset['originTop'] || 0
  const scrollToBottom = () => {
    if (dom.dataset['isFocusin'] === '0') {
      window.scrollTo({
        top: +originTop,
        behavior: 'smooth',
      })
    }
  }
  scrollToBottom()
}

// 为 native 事件做一层代理
function focusinHandler(this: HTMLElement, event: Event) {
  emitter.emit('focusin', {
    event,
    dom: this,
  })
}

function focusoutHandler(this: HTMLElement, event: Event) {
  emitter.emit('focusout', {
    event,
    dom: this,
  })
}

// 判断一下是否点击 clear 图标，针对 md-input
function clickHandler(this: Element, event: Event) {
  if (event.target instanceof HTMLElement) {
    const classMap = event.target.classList
    if (
      classMap.contains(CLEAR) &&
      classMap.contains(MD_ICON) &&
      classMap.contains(MD_ICON_CLEAR)
    ) {
      emitter.emit('focusin', {
        event,
        dom: this,
      })
    }
  }
}

const _vscrollBottom: DirectiveOptions = {
  inserted(el) {
    if (!isIOS()) return
    el.addEventListener('focusout', focusoutHandler)
    el.addEventListener('focusin', focusinHandler)
    el.addEventListener('click', clickHandler)
    emitter.on('focusin', fakeFocusin)
    emitter.on('focusout', fakeFocusout)
  },
  unbind(el) {
    if (!isIOS()) return
    el.removeEventListener('focusout', focusoutHandler)
    el.removeEventListener('focusin', focusinHandler)
    el.removeEventListener('click', clickHandler)
    emitter.off('focusin', fakeFocusin)
    emitter.off('focusout', fakeFocusout)
  },
}

const install = (Vue: typeof _Vue) => {
  Vue.directive('scrollBottom', _vscrollBottom)
}

export default {
  install,
  _vscrollBottom,
}
